import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient compartido por la app. Defaults conservadores para un SaaS:
 * reintentos moderados y datos frescos por 30s para evitar refetch agresivo.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
